import React, {FC, useEffect, useRef, useState} from "react";
import './BriteIframe.css';

interface BPProps {
    sessionToken?: string;
    triggerRedirectToTrack?: () => void;
    clearBriteSession?: () => void;
}

declare global {
    interface Window {
        Brite?: {
            new (sessionToken: string): {
                start: (
                    options: { selector: string; width?: string; height?: string },
                    stateCallback: (state: string) => void,
                    stopCallback: () => void
                ) => void;
                stop: () => void;
                STATE_COMPLETED: string;
            };
        };
    }
}

const BriteIframe: FC<BPProps> = ({ sessionToken, triggerRedirectToTrack,clearBriteSession }) => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const [showBlock, setShowBlock] = useState(false)
    const [briteScriptReady, setBriteScriptReady] = useState(!!window.Brite);

    useEffect(() => {
        // якщо вже завантажений — нічого не робимо
        if (window.Brite) {
            setBriteScriptReady(true);
            return;
        }
        let script = document.getElementById('brite-client-script') as HTMLScriptElement | null;
        if (!script) {
            script = document.createElement('script');
            script.id = 'brite-client-script';
            script.src = 'https://client.britepaymentgroup.com/client.js';
            script.async = true;
            document.body.appendChild(script);
        }
        // чекаємо завантаження
        const onLoad = () => setBriteScriptReady(true);
        script.addEventListener('load', onLoad);
        return () => script!.removeEventListener('load', onLoad);
    }, []);

    useEffect(() => {
        if (briteScriptReady && sessionToken && sessionToken.length > 0) {
            initializeBrite();
        }
    }, [briteScriptReady, sessionToken]);
    useEffect(() => {
        if (showBlock) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [showBlock]);
    const initializeBrite = () => {

        if (window.Brite && sessionToken) {
            const client = new window.Brite(sessionToken);
            let isRedirect;
            setShowBlock(true);
            client.start(
                {
                    selector: '#BritePayment',
                    width: '400px',
                    height: '600px',
                },
                (state: string) => {
                    isRedirect = state;
                    if (typeof isRedirect === "number" && isRedirect === 12) {
                        setShowBlock(false);
                        if (triggerRedirectToTrack) {
                            triggerRedirectToTrack()
                        }
                    }
                },
                () => {
                    setShowBlock(false);
                    client.stop();
                    if (clearBriteSession) {
                        clearBriteSession();
                    }
                }
            );
        } else {
            console.error('Brite client or session token is missing');
        }
    };

    return (
        <div
            id="BritePayment"
            ref={containerRef}
            style={{
                display: showBlock ? 'flex' : 'none',
                overflow: showBlock ? 'hidden' : 'none'
            }}
        ></div>
    );
};

export default BriteIframe;